export default __webpack_public_path__ + "static/media/exit1.bc0b6123.svg";